var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMyDocuments(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 60.026 78.803",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_16708",
    "data-name": "Group 16708",
    transform: "translate(-61)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_32335",
    "data-name": "Path 32335",
    d: "M118.378,16.356,103.537,2.316A8.432,8.432,0,0,0,97.72,0H69.465A8.475,8.475,0,0,0,61,8.465V70.338A8.475,8.475,0,0,0,69.465,78.8h43.1a8.475,8.475,0,0,0,8.465-8.465V22.505a8.5,8.5,0,0,0-2.648-6.149Zm-4.485,2.114H102.4a.77.77,0,0,1-.77-.77V6.87ZM112.56,74.185h-43.1a3.852,3.852,0,0,1-3.848-3.848V8.465a3.852,3.852,0,0,1,3.848-3.848h27.55V17.7a5.393,5.393,0,0,0,5.387,5.387h14.006V70.338A3.852,3.852,0,0,1,112.56,74.185Z",
    fill: "#ff0185"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32336",
    "data-name": "Path 32336",
    d: "M164.169,200H130.309a2.309,2.309,0,0,0,0,4.617h33.861a2.309,2.309,0,1,0,0-4.617Z",
    transform: "translate(-56.688 -169.218)",
    fill: "#96006b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32337",
    "data-name": "Path 32337",
    d: "M164.169,280H130.309a2.309,2.309,0,1,0,0,4.617h33.861a2.309,2.309,0,1,0,0-4.617Z",
    transform: "translate(-56.688 -236.905)",
    fill: "#96006b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32338",
    "data-name": "Path 32338",
    d: "M141.5,360H130.309a2.309,2.309,0,1,0,0,4.617H141.5a2.309,2.309,0,1,0,0-4.617Z",
    transform: "translate(-56.688 -304.592)",
    fill: "#96006b"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMyDocuments);
export default __webpack_public_path__ + "static/media/MyDocuments.22d193cf918840bc36f2f72bd5df0e8b.svg";
export { ForwardRef as ReactComponent };